@if (isLoadingNews() && liveNews().length === 0) {
  <div role="status" class="py-24 text-center flex flex-col items-center justify-center space-y-4">
    <div class="w-10 h-10 border-3 border-emerald-600 border-t-transparent rounded-full animate-spin"></div>
    <div class="text-sm font-bold text-slate-700 dark:text-slate-300">{{ game.t('dashboard.news_loading') }}</div>
  </div>
} @else {
<div class="space-y-3 sm:space-y-6 pb-16 sm:pb-8">
  <!-- News Feed Section: /api/news/units/{{ competitionUnitId }} -->
  <div class="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-5 sm:p-6 shadow-xs transition-colors">
    <!-- Header -->
    <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between pb-4 mb-4 border-b border-slate-100 dark:border-slate-800 gap-3">
      <div class="flex items-center space-x-3">
        <div class="w-10 h-10 rounded-xl bg-indigo-50 dark:bg-indigo-950/60 text-indigo-600 dark:text-indigo-400 flex items-center justify-center shrink-0 border border-indigo-100 dark:border-indigo-900/50">
          <app-icon name="newspaper" [size]="20" />
        </div>
        <div>
          <div class="flex items-center space-x-2">
            <h1 class="text-base sm:text-lg font-bold text-slate-900 dark:text-white tracking-tight">
              {{ game.t('dashboard.news_title') }}
            </h1>
            <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold bg-emerald-50 text-emerald-700 dark:bg-emerald-950/60 dark:text-emerald-300 border border-emerald-200 dark:border-emerald-800">
              <span class="w-1.5 h-1.5 rounded-full bg-emerald-500 mr-1.5 animate-pulse"></span>
              {{ game.t('dashboard.news_live') }}
            </span>
          </div>
          <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
            {{ game.t('dashboard.news_desc') }}
          </p>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex items-center space-x-2 shrink-0">
        <button type="button" (click)="loadNews(true)" [disabled]="isLoadingNews()"
          class="p-2 rounded-xl text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-800 disabled:opacity-40 cursor-pointer"
          aria-label="Actualizar noticias" title="Actualizar noticias">
          <app-icon name="refresh-cw" [size]="16" [class.animate-spin]="isLoadingNews()" />
        </button>
        <button
          type="button"
          (click)="game.setActiveTab('market')"
          class="inline-flex items-center space-x-1.5 px-3 py-1.5 text-xs font-semibold text-emerald-700 dark:text-emerald-300 bg-emerald-50 dark:bg-emerald-950/60 hover:bg-emerald-100 dark:hover:bg-emerald-900/60 rounded-xl border border-emerald-200 dark:border-emerald-800 transition-colors cursor-pointer"
        >
          <app-icon name="arrow-left-right" [size]="13" />
          <span>{{ game.t('dashboard.news_view_market') }}</span>
        </button>
      </div>
    </div>

    <!-- Error message if any -->
    @if (newsError()) {
      <div class="mb-4 px-4 py-2.5 rounded-xl bg-amber-50 border border-amber-200 text-amber-800 dark:bg-amber-950/30 dark:border-amber-800/40 dark:text-amber-300 text-xs flex items-center justify-between">
        <span class="truncate">{{ newsError() }}</span>
        <button (click)="loadNews(true)" [disabled]="isLoadingNews()" class="underline font-semibold text-xs ml-3 shrink-0 cursor-pointer">{{ game.t('dashboard.retry') }}</button>
      </div>
    }

      <div class="space-y-5" [class.opacity-60]="isLoadingNews()">
        @for (group of groupedNews(); track group.dateKey) {
          <div class="space-y-2">
            <!-- Day Group Header -->
            <div class="flex items-center justify-between pt-1">
              <div class="flex items-center space-x-2 text-xs font-bold text-slate-700 dark:text-slate-300">
                <app-icon name="calendar" [size]="14" class="text-indigo-500 dark:text-indigo-400" />
                <span>{{ group.isToday ? game.t('dashboard.news_today') : group.isYesterday ? game.t('dashboard.news_yesterday') : group.displayDate }}</span>
                @if (group.isToday) {
                  <span class="px-1.5 py-0.2 text-[10px] font-bold rounded-md bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300">
                    {{ game.t('dashboard.news_today') }}
                  </span>
                }
              </div>
              <span class="text-[11px] font-mono text-slate-400 dark:text-slate-500">
                {{ group.items.length }} {{ group.items.length === 1 ? game.t('dashboard.news_count_single') : game.t('dashboard.news_count_plural') }}
              </span>
            </div>

            <!-- List of simple title rows for this day -->
            <div class="divide-y divide-slate-100 dark:divide-slate-800 rounded-xl border border-slate-200/80 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-800/20 overflow-hidden">
              @for (item of group.items; track item.id) {
                <div class="px-3.5 py-2.5 flex flex-col items-start gap-1.5 sm:flex-row sm:items-center sm:justify-between text-xs hover:bg-slate-100/70 dark:hover:bg-slate-800/60 transition-colors">
                  <div class="flex items-start sm:items-center gap-2.5 min-w-0 w-full sm:w-auto sm:mr-3">
                    <span class="w-1.5 h-1.5 mt-1.5 sm:mt-0 rounded-full bg-indigo-500 dark:bg-indigo-400 shrink-0"></span>
                    @if (newsSponsorTitle(item); as sponsor) {
                      <span class="min-w-0 whitespace-normal [overflow-wrap:anywhere] leading-relaxed font-normal text-slate-800 dark:text-slate-200">
                        <button type="button" class="font-bold text-slate-900 dark:text-white underline decoration-dotted underline-offset-4 hover:decoration-solid hover:text-emerald-600 dark:hover:text-emerald-400 cursor-pointer rounded focus-visible:outline-2 focus-visible:outline-emerald-500"
                          [attr.aria-label]="'Ver ficha de ' + sponsor.clubName"
                          (click)="game.openClubProfile(sponsor.clubId, sponsor.clubName)">{{ sponsor.clubName }}</button>
                        <span> ha firmado con </span>
                        @if (sponsor.websiteUrl) {
                          <a [href]="sponsor.websiteUrl" target="_blank" rel="noopener noreferrer" class="italic underline decoration-dotted underline-offset-4 hover:decoration-solid"
                            [attr.aria-label]="'Abrir web de ' + sponsor.sponsorName + ' en una pestaña nueva'">{{ sponsor.sponsorName }}</a>
                        } @else {<em>{{ sponsor.sponsorName }}</em>}
                        <span> {{ sponsor.amount }}</span>
                      </span>
                    } @else if (newsAwardTitle(item); as parts) {
                      <span class="min-w-0 whitespace-normal [overflow-wrap:anywhere] leading-relaxed sm:leading-normal font-normal text-slate-800 dark:text-slate-200" [title]="item.title">
                        @for (part of parts; track $index) {
                          @if (part.kind === 'player') {
                            <button type="button" class="font-bold text-indigo-600 dark:text-indigo-400 underline decoration-dotted underline-offset-4 hover:decoration-solid cursor-pointer rounded focus-visible:outline-2 focus-visible:outline-indigo-500"
                              [attr.aria-label]="'Ver ficha de ' + part.text" (click)="openAwardPlayer(part.playerDefinitionId, part.text)">{{ part.text }}</button>
                          } @else {<span [innerHTML]="part.html"></span>}
                        }
                      </span>
                    } @else if (newsPlayerTitle(item); as parts) {
                      <span class="min-w-0 whitespace-normal [overflow-wrap:anywhere] leading-relaxed font-normal text-slate-800 dark:text-slate-200">
                        @for (part of parts; track $index) {
                          @if (part.kind === 'player') {
                            <button type="button" class="font-bold text-indigo-600 dark:text-indigo-400 underline decoration-dotted underline-offset-4 hover:decoration-solid cursor-pointer rounded focus-visible:outline-2 focus-visible:outline-indigo-500"
                              [attr.aria-label]="'Ver ficha de ' + part.text" (click)="openNewsPlayer(item)">{{ part.text }}</button>
                          } @else if (part.kind === 'club') {
                            <button
                              type="button"
                              class="font-bold text-slate-900 dark:text-white underline decoration-dotted underline-offset-4 hover:decoration-solid hover:text-emerald-600 dark:hover:text-emerald-400 cursor-pointer rounded focus-visible:outline-2 focus-visible:outline-emerald-500"
                              [attr.aria-label]="'Ver ficha de ' + part.text"
                              (click)="openNewsClub(item, part.text)"
                            >{{ part.text }}</button>
                          } @else {<span>{{ part.text }}</span>}
                        }
                      </span>
                    } @else {
                    <span
                      class="min-w-0 whitespace-normal [overflow-wrap:anywhere] leading-relaxed sm:leading-normal font-normal text-slate-800 dark:text-slate-200 sm:truncate"
                      [title]="item.title"
                      [innerHTML]="item.titleHtml || item.title"
                    ></span>
                    }
                  </div>
                  <span class="pl-4 sm:pl-0 text-[11px] text-slate-400 dark:text-slate-500 shrink-0 font-mono">
                    {{ formatNewsTime(item.occurredAt, item.publishedAt) }}
                  </span>
                </div>
              }
            </div>
          </div>
        } @empty {
          <div class="py-10 text-center text-slate-400 text-xs flex flex-col items-center justify-center space-y-2">
            <app-icon name="newspaper" [size]="24" class="text-slate-300 dark:text-slate-600" />
            <span class="font-medium">{{ game.t('dashboard.news_empty') }}</span>
          </div>
        }
      </div>
  </div>

</div>
@if (selectedNewsPlayer(); as player) {
  <app-player-profile [playerDefinitionId]="player.id" [playerName]="player.name" (closed)="selectedNewsPlayer.set(null)" />
}

}
